// import { Avatar, Modal } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import eyeIcon from "../images/eye-icon-black.png";
// import AlertComponent from "./AlertComponent";
// import ChipStaffName from "./ChipStaffName";
// import ChipStatus from "./ChipStatus";
// import RoomNumber from "./RoomNumber";

// export default function ClientWidget(props) {
//   const navigate = useNavigate();
  

//   const showIfEmpty = (value, projectedValue) => {
//     if (projectedValue) return projectedValue;
//     return value ? value : "------";
//   };

//   const showIfEmptyCI = (value) => {
//     return value ? value : "No C.Identifier";
//   };

//   const [openModal, setOpenModal] = React.useState(false);
//   const [shouldNavigate, setShouldNavigate] = React.useState(false);

//   const getAgeFromDOB = () => {
//     if (!props.dob) {
//       return "------";
//     }

//     const dobDate = props.dob.toDate(); 
//     const diff = Date.now() - dobDate.getTime();
//     const ageDate = new Date(diff);

//     return Math.abs(ageDate.getUTCFullYear() - 1970);
//   };

//   const alertCounts = {
//     reminders: 0,
//     allergies: 0,
//     alerts: 0,
//   };

//   (props.alerts || []).forEach((alert) => {
//     switch (
//       alert.type 
//     ) {
//       case 1:
//         alertCounts.reminders += 1;
//         break;
//       case 2:
//         alertCounts.allergies += 1;
//         break;
//       case 3:
//         alertCounts.alerts += 1;
//         break;
//       default:
//         break;
//     }
//   });

//   const [age, setAge] = useState(getAgeFromDOB());

//   useEffect(() => {
//     setAge(getAgeFromDOB());
//   }, [props.dob]);

//   const handleOpenModal = () => {
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//   };

//   const handleNavigate = () => {
//     setShouldNavigate(true);
//   };

//   React.useEffect(() => {
//     if (shouldNavigate) {
//       navigate(`/client/${props.docId}`, {
//         state: props, // Passez l'objet client complet
//       });
//     }
//   }, [shouldNavigate]);

//   return (
//     <div className="client-widget-container">
//       <div className="line1-client-widget">
//         <div className="left-line-top-widget">
//           <div className="left-top-30">
//             <ChipStatus status={showIfEmpty(props.clientStatus)} />
//             <div onClick={handleOpenModal}>
//               <Avatar
//                 src={props.profilePic}
//                 style={{
//                   width: "35px",
//                   height: "35px",
//                   marginLeft: "0px",
//                   marginTop: "3px",
//                   cursor: "pointer",
//                 }}
//               />
//             </div>
//           </div>
//           <div className="left-top-70">
//             <div className="widget-firstname">
//               {showIfEmpty(props.firstnameClient)}
//             </div>
//             <div className="widget-lastname">
//               {showIfEmpty(props.lastnameClient)}
//             </div>
//           </div>
//         </div>
//         <div className="right-line-widget2">
//           <div className="client-widget-info-text1bis">
//             {/* C.I.:  */}
//             {showIfEmptyCI(props.clientIdentifier)}
//           </div>
//           <div
//             className="client-widget-info-text2"
//             title="As Known As : Nickname"
//           >
//             AKA: {showIfEmpty(props.aka)}
//           </div>
//           <div className="client-widget-info-text2">
//             Age: {age} {/* Age: {showIfEmpty(props.age)}{" "} */}
//           </div>
//         </div>
//       </div>
//       <div className="line2-client-widget">
//         <div className="left-line-widget-column">
//           <div className="client-widget-info-text3">
//             Arrival date: {showIfEmpty(props.arrivalDate)}
//           </div>
//           <div
//             className="client-widget-info-text3"
//             title="Intended Discharge Date"
//           >
//             I.D.D. :{" "}
//             {showIfEmpty(props.idd, props.projectedResidentialDischargeDate)}
//           </div>
//           <div
//             className="client-widget-info-text3"
//             title="Intended Length of Stay"
//           >
//             I.L.S. : {showIfEmpty(props.ils)}
//           </div>
//         </div>
//         <div className="right-line-widget3">
//           {alertCounts.reminders > 0 && (
//             <AlertComponent text={`Reminders: ${alertCounts.reminders}`} />
//           )}
//           {/* {props.alertType1 && props.alertType2.length > 0 && (
//             <AlertComponent text="Reminders!" />
//           )} */}
//         </div>
//       </div>
//       <div className="line3-client-widget">
//         <div className="left60-line-widget">
//           <div className="left1-line-widget">
//             <ChipStaffName
//               assignedTherapist={showIfEmpty(props.assignedTherapist)}
//             />
//           </div>
//           <div className="left2-line-widget">
//             <RoomNumber roomNumber={showIfEmpty(props.roomNumber)} />
//           </div>
//         </div>
//         <div className="right40-line-widget">
//           {alertCounts.allergies > 0 && (
//             <AlertComponent text={`Allergies: ${alertCounts.allergies}`} />
//           )}
//           {/* {props.alertType2 && props.alertType2.length > 0 && (
//             <AlertComponent text="Allergies!" />
//           )} */}
//           {alertCounts.alerts > 0 && (
//             <AlertComponent text={`Alerts: ${alertCounts.alerts}`} />
//           )}
//           {/* {props.alertType3 && props.alertType3.length > 0 && (
//             <AlertComponent text="Alerts!" />
//           )} */}
//         </div>
//       </div>
//       <div className="line4-client-widget">
//         {" "}
//         <div className="left100-line-widget">
//           <img className="eye-icon" src={eyeIcon} />
//           <Link
//             // to="/client"
//             className="link-widget"
//             onClick={handleNavigate}
//           >
//             <p className="title-text-button-widget"> VIEW PROFILE</p>
//           </Link>
//         </div>
//         {/* <div className="right50-line-widget">
//           <img className="notes-icon" src={notesIcon} />
//           <p className="title-text-button-widget"> Add quick note</p>
//         </div> */}
//       </div>

//       <Modal
//         open={openModal}
//         onClose={handleCloseModal}
//         aria-labelledby="modal-image"
//         aria-describedby="image-full-size"
//       >
//         <div
//           onClick={handleCloseModal}
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "100%",
//             height: "100%",
//             position: "absolute",
//             top: 0,
//             left: 0,
//             backgroundColor: "rgba(0, 0, 0, 0.3)",
//           }}
//         >
//           <img
//             src={props.profilePic}
//             alt="Full-size profile picture"
//             style={{
//               maxWidth: "90%",
//               maxHeight: "90%",
//               objectFit: "contain",
//             }}
//           />
//         </div>
//       </Modal>
//     </div>
//   );
// }

import { Avatar, Chip, Modal } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import eyeIcon from "../images/eye-icon-black.png";
import AlertComponent from "./AlertComponent";
import ChipStaffName from "./ChipStaffName";
import ChipStatus from "./ChipStatus";
import RoomNumber from "./RoomNumber";
import "./ClientCardCompactRedesign.css";
import { getRehabByClient } from "../api/rehabs";

export default function ClientWidget(props) {
  const navigate = useNavigate();

  const showIfEmpty = (value, projectedValue) => {
    if (projectedValue) return projectedValue;
    return value ? value : "------";
  };

  const showIfEmptyCI = (value) => {
    return value ? value : "No C.Identifier";
  };

  const hasMobileUid = !!String(props.mobileUid || "").trim();
  const rehab = getRehabByClient(props);
  const rehabCode = rehab?.country === "Philippines" ? "PH" : "TH";

  const [openModal, setOpenModal] = React.useState(false);

  const getAgeFromDOB = () => {
    if (!props.dob) {
      return "------";
    }

    const dobDate = props.dob.toDate();
    const diff = Date.now() - dobDate.getTime();
    const ageDate = new Date(diff);

    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const alertCounts = {
    reminders: 0,
    allergies: 0,
    alerts: 0,
  };

  (props.alerts || []).forEach((alert) => {
    switch (alert.type) {
      case 1:
        alertCounts.reminders += 1;
        break;
      case 2:
        alertCounts.allergies += 1;
        break;
      case 3:
        alertCounts.alerts += 1;
        break;
      default:
        break;
    }
  });

  const age = getAgeFromDOB();

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleNavigate = () => {
    navigate(`/client/${props.docId}`, {
      state: props,
    });
  };

  return (
    <div className="client-widget-container">
      <span
        className={`client-rehab-badge client-rehab-badge-${rehabCode.toLowerCase()}`}
        title={rehab?.name}
      >
        {rehabCode}
      </span>
      <div className="line1-client-widget">
        <div className="left-line-top-widget">
          <div className="left-top-30-v3" style={{fontSize:"10px"}}>
            {/* ChipStatus reste inchang?? */}
            <ChipStatus
              status={showIfEmpty(props.clientStatus)}
              rehabId={props.rehabId}
              rehabCountry={props.rehabCountry}
            />

            {/* Affichage des alertes ?? la place du nom et pr??nom */}
            {alertCounts.reminders > 0 && (
              <AlertComponent text={`Reminder: ${alertCounts.reminders}`} />
            )}
            {alertCounts.allergies > 0 && (
              <AlertComponent text={`Allergie: ${alertCounts.allergies}`} />
            )}
            {alertCounts.alerts > 0 && (
              <AlertComponent text={`Alerts: ${alertCounts.alerts}`} />
            )}
          </div>

          <div className="left-top-70">
            {/* Affichage du nom et pr??nom ?? la place des alertes */}
            <div className="widget-firstname">
              {showIfEmpty(props.firstnameClient)}
            </div>
            <div className="widget-lastname">
              {showIfEmpty(props.lastnameClient)}
            </div>
          </div>
        </div>

        <div className="right-line-widget2">

        <div onClick={handleOpenModal} style={{display:'flex',justifyContent:'center'}}>
            <Avatar
              src={props.profilePic}
              style={{
                width: "80px",
                height: "80px",
                marginLeft: "0px",
                marginTop: "3px",
                cursor: "pointer",
              }}
            />
          </div>
          
        </div>
      </div>

      <div className="line2-client-widget">
        <div className="left-line-widget-column">
          <div className="client-widget-info-text3">
            Arrival date: {showIfEmpty(props.arrivalDate)}
          </div>
          <div
            className="client-widget-info-text3"
            title="Intended Discharge Date"
          >
            I.D.D. :{" "}
            {showIfEmpty(props.idd, props.projectedResidentialDischargeDate)}
          </div>
          <div
            className="client-widget-info-text3"
            title="Intended Length of Stay"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <span>I.L.S. : {showIfEmpty(props.ils)}</span>
            {hasMobileUid && (
              <Chip
                label="Mobile active"
                size="small"
                sx={{
                  height: 22,
                  background:
                    "linear-gradient(90deg, #0f766e 0%, #14b8a6 100%)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "0.66rem",
                }}
              />
            )}
          </div>
        </div>

        <div className="right-line-widget3" >
          {/* L'Avatar reste ?? sa position actuelle */}
          <div className="client-widget-info-text1bis" style={{display:'flex',justifyContent:'center',width:'100%',fontSize:"10px"}}>
            {showIfEmptyCI(props.clientIdentifier)}
          </div>
          
        </div>
      </div>

      <div className="line3-client-widget">
        <div className="left60-line-widget">
          <div className="left1-line-widget">
            <ChipStaffName
              assignedTherapist={showIfEmpty(props.assignedTherapist)}
            />
          </div>
          <div className="left2-line-widget">
            <RoomNumber roomNumber={showIfEmpty(props.roomNumber)} />
          </div>
        </div>

        <div className="right40-line-widget" style={{display:'flex',justifyContent:'center', flexDirection:'column',textAlign:'center',fontSize:"12px"}}>
        <div
            className="client-widget-info-text2"
            title="As Known As : Nickname"
            style={{fontSize:"12px"}}
          >
            AKA: {showIfEmpty(props.aka)}
          </div>
          <div className="client-widget-info-text2" style={{fontSize:"12px"}}>
            Age: {age}
          </div>
          {/* Vous pouvez ajouter d'autres ??l??ments ici si n??cessaire */}
        </div>
      </div>

      <div className="line4-client-widget">
        <div className="left100-line-widget">
          <img className="eye-icon" src={eyeIcon} alt="View Icon" />
          <button className="link-widget" type="button" onClick={handleNavigate}>
            <p className="title-text-button-widget"> VIEW PROFILE</p>
          </button>
        </div>
      </div>

      {/* Modal pour afficher l'image en taille r??elle */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-image"
        aria-describedby="image-full-size"
      >
        <div
          onClick={handleCloseModal}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          }}
        >
          <img
            src={props.profilePic}
            alt={
              `${props.firstnameClient || ""} ${
                props.lastnameClient || ""
              }`.trim() || "Client"
            }
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
          />
        </div>
      </Modal>
    </div>
  );
}
